module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('modal', {
    attrs: {
      "large": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.exportHistiryModal),
      callback: function($$v) {
        _vm.exportHistiryModal = $$v
      },
      expression: "exportHistiryModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.exportHeadColumns,
      "footColumns": _vm.exportFootColumns,
      "rows": _vm.exportRows,
      "title": ("" + (_vm.$t('statistic.payment_history')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportHistiryModal = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('verbs.close')) + "\n            ")])])], 1), _vm._v(" "), _c('OrderTable', {
    key: 'order-table-remnants',
    attrs: {
      "title": ("" + (_vm.$t('pages.remnants'))),
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "disableActionBTN": true,
      "isLoading": _vm.loading,
      "idElem": 'remnants'
    },
    on: {
      "changeVal": _vm.changeVal
    }
  }, [_c('template', {
    slot: "table-actions"
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.toggleExportHistoryModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0274360c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/Remnants.vue
// module id = 503
// module chunks = 0